// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurrencyManagement-space1-OGFwt {
	margin-bottom: 6px !important;
}

.CurrencyManagement-space2-GCc5U {
	margin-bottom: 12px !important;
}

.CurrencyManagement-space3-FZfQ6 {
	margin-bottom: 18px !important;
}

.CurrencyManagement-space4-VP4ag {
	margin-bottom: 24px !important;
}

.CurrencyManagement-space5-iN7sh {
	margin-bottom: 30px !important;
}

.CurrencyManagement-space6-Ipfjy {
	margin-bottom: 36px !important;
}

.CurrencyManagement-space7-QZmq4 {
	margin-bottom: 42px !important;
}

.CurrencyManagement-space8-dhAer {
	margin-bottom: 48px !important;
}

.CurrencyManagement-spaceTop1-oauyP {
	margin-top: 6px !important;
}

.CurrencyManagement-spaceTop2-w8K_a {
	margin-top: 12px !important;
}

.CurrencyManagement-spaceTop3-nnlGP {
	margin-top: 18px !important;
}

.CurrencyManagement-spaceTop4-NJvix {
	margin-top: 24px !important;
}

.CurrencyManagement-spaceTop5-ktPHn {
	margin-top: 30px !important;
}

.CurrencyManagement-spaceTop6-_7Vph {
	margin-top: 36px !important;
}

.CurrencyManagement-spaceTop7-yiufy {
	margin-top: 42px !important;
}

.CurrencyManagement-spaceTop8-yCxpA {
	margin-top: 48px !important;
}

.CurrencyManagement-noMargin-_BGm6 {
	margin: 0px !important;
}

.CurrencyManagement-padding1-Xph54 {
	padding-bottom: 6px !important;
}

.CurrencyManagement-padding2-ehd11 {
	padding-bottom: 12px !important;
}

.CurrencyManagement-padding3-C7Zmz {
	padding-bottom: 18px !important;
}

.CurrencyManagement-padding4-T5RTA {
	padding-bottom: 24px !important;
}

.CurrencyManagement-padding5-z7JEV {
	padding-bottom: 30px !important;
}

.CurrencyManagement-padding6-eicQI {
	padding-bottom: 36px !important;
}

.CurrencyManagement-padding7-WXIwC {
	padding-bottom: 42px !important;
}

.CurrencyManagement-paddingTop1-BXcMT {
	padding-top: 6px !important;
}

.CurrencyManagement-paddingTop2-TMx7L {
	padding-top: 12px !important;
}

.CurrencyManagement-paddingTop3-Fcs0j {
	padding-top: 18px !important;
}

.CurrencyManagement-paddingTop4-bSmN9 {
	padding-top: 24px !important;
}

.CurrencyManagement-paddingTop5-xiPCb {
	padding-top: 30px !important;
}

.CurrencyManagement-paddingTop6-tAIV3 {
	padding-top: 36px !important;
}

.CurrencyManagement-paddingTop7-t495H {
	padding-top: 42px !important;
}

.CurrencyManagement-noPadding-kfWXD {
	padding: 0px !important;
}

.CurrencyManagement-spaceMarginBottom0-cx5De {
	margin-bottom: 0;
}

.CurrencyManagement-textBold-fQs9u {
	font-weight: 500 !important;
}

.CurrencyManagement-textBolder-jcB5J {
	font-weight: 700 !important;
}

.CurrencyManagement-textNormal-m8ex3 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.CurrencyManagement-textDarkBlue-gTI1L {
	color: rgb(20, 39, 94) !important;
}

.CurrencyManagement-textLightBlue-cPv9x {
	color: rgb(57, 87, 106) !important;
}

.CurrencyManagement-textLightSandleGreen-ZmksY {
	color: rgb(76, 86, 41) !important;
}

.CurrencyManagement-textLightBrown-a9IWJ {
	color: rgb(115, 79, 33) !important;
}

.CurrencyManagement-textMediumMaroon-P8BOc {
	color: rgb(87, 37, 51) !important;
}

.CurrencyManagement-textBrown-_w1Lg {
	color: rgb(160, 47, 24) !important;
}

.CurrencyManagement-textMaroon-u2lPS {
	color: rgb(155, 49, 67) !important;
}

.CurrencyManagement-textDarkBrown-xnjR2 {
	color: rgb(83, 18, 16) !important;
}

.CurrencyManagement-textMediumBrown-bBdEw {
	color: rgb(142, 28, 10) !important;
}

.CurrencyManagement-textSkyBlue-XmBwY {
	color: rgb(37, 117, 141) !important;
}

.CurrencyManagement-textGray-vSGhM {
	color: rgb(77, 65, 51) !important;
}

.CurrencyManagement-errorMessage-JxKJM {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.CurrencyManagement-userText-9wfVK {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.CurrencyManagement-panelHeader-dXCJz {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.CurrencyManagement-exportSection-p9Sk1 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.CurrencyManagement-exportSectionGridSub-dnxRp {
	grid-template-columns: 50% 49% !important;
}

.CurrencyManagement-exportText-JKdhM {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.CurrencyManagement-exportLinkImg-WZEIq {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.CurrencyManagement-exportImg-osaeC {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.CurrencyManagement-linkBtn-g6I5W {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.CurrencyManagement-table-aZxo5 {
	display: table;
}

.CurrencyManagement-tableRow-yuPKN {
	display: table-row;
}

.CurrencyManagement-tableCell-K97oK {
	display: table-cell;
	float: none;
}

.CurrencyManagement-formGroup-GdpVT {
	margin-bottom: 6px;
}

.CurrencyManagement-marginTop0-uG3nW {
	margin-top: 0;
}

.CurrencyManagement-marginBottom20-zosAN {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.CurrencyManagement-bannerImageBg-nhwof {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.CurrencyManagement-bannerDelete-t3Krm {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.CurrencyManagement-exportLink-fIr7M {
	padding-top: 10px;
	padding-right: 10px;
}

.CurrencyManagement-seachContent-m_CNV {
	padding-left: 0px;
	margin-bottom: 5px;
}

.CurrencyManagement-marginBottom9-F97lA {
	margin-bottom: 9px;
}

.CurrencyManagement-spaceTop52-mK3GI {
	margin-top: 52px;
}

.CurrencyManagement-profileViewInner-eseKA {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.CurrencyManagement-profileViewMain-q44E_ {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.CurrencyManagement-profileViewlabel-U3Vtc {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.CurrencyManagement-profileViewMainContent-Qau0N {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.CurrencyManagement-reviewsFormStar-lctjl {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.CurrencyManagement-reviewsFormStar-lctjl svg {
	cursor: pointer;
}

.CurrencyManagement-addLanguageText-qi0zZ {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.CurrencyManagement-exportSection-p9Sk1 {
		grid-template-columns: 100%;
	}

	.CurrencyManagement-spaceTop52-mK3GI {
		margin-top: 18px;
	}

	.CurrencyManagement-exportText-JKdhM {
		float: none;
		margin-top: 12px;
	}

	.CurrencyManagement-exportSectionGridSub-dnxRp {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.CurrencyManagement-profileViewlabel-U3Vtc {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.CurrencyManagement-profileViewMainContent-Qau0N {
		width: 100%;
		text-align: center;
	}

	.CurrencyManagement-panelHeader-dXCJz {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.CurrencyManagement-listContainer-qHfNB {
  padding: 0px;
  list-style-type: none;
}

.CurrencyManagement-listContent-gtS7l {
  margin-bottom: 30px;
  font-size: 18px;
}

.CurrencyManagement-checkBoxSection-Effqm {
  display: table-cell;
}

.CurrencyManagement-checkBoxLabel-opAxt {
  padding: 0px 10px;
}

.CurrencyManagement-noPadding-kfWXD {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/CurrencyManagement/CurrencyManagement.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n\n.listContainer {\n  padding: 0px;\n  list-style-type: none;\n}\n\n.listContent {\n  margin-bottom: 30px;\n  font-size: 18px;\n}\n\n.checkBoxSection {\n  display: table-cell;\n}\n\n.checkBoxLabel {\n  padding: 0px 10px;\n}\n\n.noPadding {\n  padding: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `CurrencyManagement-space1-OGFwt`,
	"space2": `CurrencyManagement-space2-GCc5U`,
	"space3": `CurrencyManagement-space3-FZfQ6`,
	"space4": `CurrencyManagement-space4-VP4ag`,
	"space5": `CurrencyManagement-space5-iN7sh`,
	"space6": `CurrencyManagement-space6-Ipfjy`,
	"space7": `CurrencyManagement-space7-QZmq4`,
	"space8": `CurrencyManagement-space8-dhAer`,
	"spaceTop1": `CurrencyManagement-spaceTop1-oauyP`,
	"spaceTop2": `CurrencyManagement-spaceTop2-w8K_a`,
	"spaceTop3": `CurrencyManagement-spaceTop3-nnlGP`,
	"spaceTop4": `CurrencyManagement-spaceTop4-NJvix`,
	"spaceTop5": `CurrencyManagement-spaceTop5-ktPHn`,
	"spaceTop6": `CurrencyManagement-spaceTop6-_7Vph`,
	"spaceTop7": `CurrencyManagement-spaceTop7-yiufy`,
	"spaceTop8": `CurrencyManagement-spaceTop8-yCxpA`,
	"noMargin": `CurrencyManagement-noMargin-_BGm6`,
	"padding1": `CurrencyManagement-padding1-Xph54`,
	"padding2": `CurrencyManagement-padding2-ehd11`,
	"padding3": `CurrencyManagement-padding3-C7Zmz`,
	"padding4": `CurrencyManagement-padding4-T5RTA`,
	"padding5": `CurrencyManagement-padding5-z7JEV`,
	"padding6": `CurrencyManagement-padding6-eicQI`,
	"padding7": `CurrencyManagement-padding7-WXIwC`,
	"paddingTop1": `CurrencyManagement-paddingTop1-BXcMT`,
	"paddingTop2": `CurrencyManagement-paddingTop2-TMx7L`,
	"paddingTop3": `CurrencyManagement-paddingTop3-Fcs0j`,
	"paddingTop4": `CurrencyManagement-paddingTop4-bSmN9`,
	"paddingTop5": `CurrencyManagement-paddingTop5-xiPCb`,
	"paddingTop6": `CurrencyManagement-paddingTop6-tAIV3`,
	"paddingTop7": `CurrencyManagement-paddingTop7-t495H`,
	"noPadding": `CurrencyManagement-noPadding-kfWXD`,
	"spaceMarginBottom0": `CurrencyManagement-spaceMarginBottom0-cx5De`,
	"textBold": `CurrencyManagement-textBold-fQs9u`,
	"textBolder": `CurrencyManagement-textBolder-jcB5J`,
	"textNormal": `CurrencyManagement-textNormal-m8ex3`,
	"textDarkBlue": `CurrencyManagement-textDarkBlue-gTI1L`,
	"textLightBlue": `CurrencyManagement-textLightBlue-cPv9x`,
	"textLightSandleGreen": `CurrencyManagement-textLightSandleGreen-ZmksY`,
	"textLightBrown": `CurrencyManagement-textLightBrown-a9IWJ`,
	"textMediumMaroon": `CurrencyManagement-textMediumMaroon-P8BOc`,
	"textBrown": `CurrencyManagement-textBrown-_w1Lg`,
	"textMaroon": `CurrencyManagement-textMaroon-u2lPS`,
	"textDarkBrown": `CurrencyManagement-textDarkBrown-xnjR2`,
	"textMediumBrown": `CurrencyManagement-textMediumBrown-bBdEw`,
	"textSkyBlue": `CurrencyManagement-textSkyBlue-XmBwY`,
	"textGray": `CurrencyManagement-textGray-vSGhM`,
	"errorMessage": `CurrencyManagement-errorMessage-JxKJM`,
	"userText": `CurrencyManagement-userText-9wfVK`,
	"panelHeader": `CurrencyManagement-panelHeader-dXCJz`,
	"exportSection": `CurrencyManagement-exportSection-p9Sk1`,
	"exportSectionGridSub": `CurrencyManagement-exportSectionGridSub-dnxRp`,
	"exportText": `CurrencyManagement-exportText-JKdhM`,
	"exportLinkImg": `CurrencyManagement-exportLinkImg-WZEIq`,
	"exportImg": `CurrencyManagement-exportImg-osaeC`,
	"linkBtn": `CurrencyManagement-linkBtn-g6I5W`,
	"table": `CurrencyManagement-table-aZxo5`,
	"tableRow": `CurrencyManagement-tableRow-yuPKN`,
	"tableCell": `CurrencyManagement-tableCell-K97oK`,
	"formGroup": `CurrencyManagement-formGroup-GdpVT`,
	"marginTop0": `CurrencyManagement-marginTop0-uG3nW`,
	"marginBottom20": `CurrencyManagement-marginBottom20-zosAN`,
	"bannerImageBg": `CurrencyManagement-bannerImageBg-nhwof`,
	"bannerDelete": `CurrencyManagement-bannerDelete-t3Krm`,
	"exportLink": `CurrencyManagement-exportLink-fIr7M`,
	"seachContent": `CurrencyManagement-seachContent-m_CNV`,
	"marginBottom9": `CurrencyManagement-marginBottom9-F97lA`,
	"spaceTop52": `CurrencyManagement-spaceTop52-mK3GI`,
	"profileViewInner": `CurrencyManagement-profileViewInner-eseKA`,
	"profileViewMain": `CurrencyManagement-profileViewMain-q44E_`,
	"profileViewlabel": `CurrencyManagement-profileViewlabel-U3Vtc`,
	"profileViewMainContent": `CurrencyManagement-profileViewMainContent-Qau0N`,
	"reviewsFormStar": `CurrencyManagement-reviewsFormStar-lctjl`,
	"addLanguageText": `CurrencyManagement-addLanguageText-qi0zZ`,
	"listContainer": `CurrencyManagement-listContainer-qHfNB`,
	"listContent": `CurrencyManagement-listContent-gtS7l`,
	"checkBoxSection": `CurrencyManagement-checkBoxSection-Effqm`,
	"checkBoxLabel": `CurrencyManagement-checkBoxLabel-opAxt`
};
module.exports = ___CSS_LOADER_EXPORT___;
